import { createAsyncThunk } from '@reduxjs/toolkit';
import personApi from '~/apis/person';
import {
  IEditPerson,
  IInputGeofencePerson,
  IParamsPerson,
  IPerson,
  IResponseGetPerson,
} from '~/utils/interface/person';

export const handleGetPersonList = createAsyncThunk<IResponseGetPerson, IParamsPerson>(
  'GET_PERSON_LIST',
  async (params: IParamsPerson = {}, { rejectWithValue }) => {
    try {
      const res = await personApi.getList(params);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreatePerson = createAsyncThunk<IPerson, IEditPerson>(
  'CREATE_PERSON',
  async (data: IEditPerson, { rejectWithValue }) => {
    try {
      const res = await personApi.create(data);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const handleUpdatePerson = createAsyncThunk<IPerson, { id: string; params: IEditPerson }>(
  'UPDATE_PERSON',
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await personApi.update(id, params);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const handleAssignGeofence = createAsyncThunk<null, IInputGeofencePerson>(
  'ADD_GEOFENCE',
  async (data: IInputGeofencePerson, { rejectWithValue }) => {
    try {
      const res = await personApi.assignGeofence(data);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const handleUnassgignGeofence = createAsyncThunk<null, IInputGeofencePerson>(
  'REMOVE_GEOFENCE',
  async (data: IInputGeofencePerson, { rejectWithValue }) => {
    try {
      const res = await personApi.unassignGeofence(data);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
